module.exports = __webpack_public_path__ + "img/uid-token-login.606cd7f1.png";